export const selectCourses = state => state.courses;